<style lang="scss">
  .container-icon-statistic{
    width: 58px;
  }

  .container-card{
    height: 255px;
  }

</style>
<template>
    <vx-card class="overflow-hidden container-card">
      <div slot="no-body">
        <div class="p-6 text-center">
          <div v-if="img === 'temperature'" class="shadow-drop d-theme-dark-bg cursor-pointer round py-3 m-auto container-icon-statistic">
              <img :src="getImgUrl(img)" class="m-auto w-4" alt="ícono"/>
          </div>
          <div v-if="img === 'humedad'" class="shadow-drop d-theme-dark-bg cursor-pointer round p-4 m-auto container-icon-statistic">
              <img :src="getImgUrl(img)" class="m-auto w-6" alt="ícono"/>
          </div>
          <div v-if="img === 'co2_blue'" class="shadow-drop d-theme-dark-bg cursor-pointer round p-4 m-auto container-icon-statistic">
              <img :src="getImgUrl(img)" class="m-auto w-8" alt="ícono"/>
          </div>
          <div class="truncate mt-4">
              <h2 class="mb-1 font-bold">{{ value }} <span class="unit">{{unit}}</span></h2>
              <span>{{ title }}</span>
              <div>{{subtitle == ''?this.$t('Labels.Average'):subtitle}}</div>
          </div>
          <div class="flex mt-3">
            <div class="flex-1" v-if="min !== undefined">
              <div class="mb-1">{{ min }} <span class="unit">{{unit}}</span></div>
              <div>Min</div>
            </div>
            <div class="flex-1" v-if="max !== undefined">
              <div class="mb-1">{{ max }} <span class="unit">{{unit}}</span></div>
              <div>Max</div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
</template>
<script>

export default {
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    min: {
      type: [Number, String],
      required: 0
    },
    max: {
      type: [Number, String],
      required: 0
    },
    title: {
      type: String
    },
    img: {
      type: String,
      default: ''
    },
    unit: {
      type: String
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  methods: {
    getImgUrl (name) {
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${name}.svg`)
    }
  }
}
</script>
